(function () {
  function initMysteryBundles() {
    document.querySelectorAll('[data-smb-atc]').forEach(function (btn) {
      if (btn._smbHooked) return;
      btn._smbHooked = true;
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;
        btn.disabled = true;
        var orig = btn.innerHTML;
        btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation:smb-spin 0.7s linear infinite"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            btn.innerHTML = orig;
            btn.disabled = false;
            if (typeof SLIDECART_UPDATE === 'function') SLIDECART_UPDATE();
            if (typeof SLIDECART_OPEN === 'function') SLIDECART_OPEN();
          })
          .catch(function () {
            btn.innerHTML = orig;
            btn.disabled = false;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMysteryBundles);
  } else {
    initMysteryBundles();
  }
  document.addEventListener('shopify:section:load', initMysteryBundles);
})();
